import { render } from "./MenteeSuggestionPage.vue?vue&type=template&id=f43f19b0&scoped=true"
import script from "./MenteeSuggestionPage.vue?vue&type=script&lang=js"
export * from "./MenteeSuggestionPage.vue?vue&type=script&lang=js"

import "./MenteeSuggestionPage.vue?vue&type=style&index=0&id=f43f19b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f43f19b0"]])

export default __exports__